<button [class.invisible]="!hasParent" (click)="navigateBack()" class="flex px-4 items-center h-10 justify-center">
  <i class="fas fa-arrow-left"></i>
</button>
